/* eslint-disable */
export default {
  to: 'A:',
  enterNameOrPhoneNumber: 'Immetti numero',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"enterNameOrPhoneNumber"@#@ @source: @#@"Enter Number"@#@
